export const animateSvg = () => {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const siteMapId = document.getElementById('right-line')
  if (siteMapId) {
    if (window.innerWidth <= 1400) {
      siteMapId.setAttribute('viewBox', '0 0 100 4');
      siteMapId.setAttribute('width', '100');
    } else {
      siteMapId.setAttribute('viewBox', '0 0 242 4');
      siteMapId.setAttribute('width', '242');
    }
  }
  const arrows = document.querySelectorAll('.arrows-contact')
  if (window.innerWidth >= 1200 && arrows) {
    if (!isSafari) {
      arrows.forEach(el => {
        /* eslint-disable no-param-reassign */
        el.onmouseover = () => {
          el.querySelector('.arrows-svg path:nth-child(1)').setAttribute('d', 'M-1.875 19.5L30.875 19.5');
        };
        el.onmouseout = () => {
          el.querySelector('.arrows-svg path:nth-child(1)').setAttribute('d', 'M8.125 19.5L30.875 19.5');
        };
      });
    } else {
      arrows.forEach(el => {
        /* eslint-disable no-param-reassign */
        el.onmouseover = () => {
          el.querySelector('.arrows-svg1').setAttribute('from', 'M8.125 19.5L30.875 19.5');
          el.querySelector('.arrows-svg1').setAttribute('to', 'M-1.875 19.5L30.875 19.5');
          el.querySelector('.arrows-svg1').beginElement();
        };
        el.onmouseout = () => {
          el.querySelector('.arrows-svg1').setAttribute('to', 'M8.125 19.5L30.875 19.5');
          el.querySelector('.arrows-svg1').setAttribute('from', 'M-1.875 19.5L30.875 19.5');
          el.querySelector('.arrows-svg1').beginElement();
        };
      });
    }
  }
  const circle = document.getElementById('circle-svg')
  if (window.innerWidth >= 1200 && circle) {
    circle.onmouseover = () => {
      document.querySelector('.circle-svg').setAttribute('stroke', 'url(#paint0_linear_165_1196)');
      document.querySelector('.circle-svg').setAttribute('opacity', '0.68');
      document.querySelector('.circle-svg-arrows path:nth-child(1)').setAttribute('d', 'M28.5762 8.99976V49.3945');
      document.querySelector('.circle-svg-arrows path:nth-child(2)').setAttribute('d', 'M40.7737 37.1975L28.5763 49.3949L16.3789 37.1975');
    };
    circle.onmouseout = () => {
      document.querySelector('.circle-svg').setAttribute('stroke', 'white');
      document.querySelector('.circle-svg').setAttribute('opacity', '0.25');
      document.querySelector('.circle-svg-arrows path:nth-child(1)').setAttribute('d', 'M28.5762 12.3789V44.7737');
      document.querySelector('.circle-svg-arrows path:nth-child(2)').setAttribute('d', 'M44.7737 28.5762L28.5763 44.7735L12.3789 28.5762');
    };
  }
  function animateSvgPath(id, startAnimate, endAnimate) {
    const idElement = document.getElementById(id)
    if (window.innerWidth >= 1200 && idElement) {
      if (isSafari) {
        Object.keys(startAnimate).forEach(key => {
          document.querySelector(`.${id} path:nth-child(${key})`).setAttribute('id', `${key}${id}`);
          const animate = document.createElementNS('http://www.w3.org/2000/svg', 'animate')
          animate.setAttribute('dur', '0.8s')
          animate.setAttribute('attributeName', 'd')
          animate.setAttribute('attributeType', 'XML')
          animate.setAttribute('fill', 'freeze')
          animate.setAttribute('restart', 'whenNotActive')
          animate.setAttribute('repeatCount', '1')
          animate.setAttribute('id', `${id}${key}`)
          animate.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', `#${key}${id}`)
          document.querySelector(`.${id}`).appendChild(animate)
        });
        idElement.onmouseenter = () => {
          Object.keys(startAnimate).forEach(key => {
            document.getElementById(`${id}${key}`).setAttribute('from', endAnimate[key]);
            document.getElementById(`${id}${key}`).setAttribute('to', startAnimate[key]);
            document.getElementById(`${id}${key}`).beginElement();
          });
        };
        idElement.onmouseleave = () => {
          Object.keys(endAnimate).forEach(key => {
            document.getElementById(`${id}${key}`).setAttribute('from', startAnimate[key]);
            document.getElementById(`${id}${key}`).setAttribute('to', endAnimate[key]);
            document.getElementById(`${id}${key}`).beginElement();
          });
        };
      } else {
        idElement.onmouseover = () => {
          Object.keys(startAnimate).forEach(key => {
            document.querySelector(`.${id} path:nth-child(${key})`).setAttribute('d', startAnimate[key]);
          });
        };
        idElement.onmouseout = () => {
          Object.keys(endAnimate).forEach(key => {
            document.querySelector(`.${id} path:nth-child(${key})`).setAttribute('d', endAnimate[key]);
          });
        };
      }
    }
  }

  const startPlanet = {
    6: 'M46 40C46 52.7026 43.3137 63 40 63C36.6863 63 34 52.7026 34 40C34 27.2974 36.6863 17 40 17C43.3137 17 46 27.2974 46 40Z',
    7: 'M68 21.6875C68 24.2763 70.0987 26.375 72.6875 26.375C75.2762 26.375 77.375 24.2763 77.375 21.6875C77.375 19.0988 75.2762 17 72.6875 17C70.0987 17 68 19.0988 68 21.6875Z',
    8: 'M2 58.6875C2 61.2763 4.09874 63.375 6.68749 63.375C9.27623 63.375 11.375 61.2763 11.375 58.6875C11.375 56.0988 9.27623 54 6.68749 54C4.09874 54 2 56.0988 2 58.6875Z',

  }
  const endPlanet = {
    6: 'M49.3749 40.0001C49.3749 52.9443 45.1776 63.4375 40 63.4375C34.8223 63.4375 30.625 52.9443 30.625 40.0001C30.625 27.0559 34.8223 16.5626 40 16.5626C45.1776 16.5626 49.3749 27.0559 49.3749 40.0001Z',
    7: 'M63.4375 16.5625C63.4375 19.1513 65.5362 21.25 68.125 21.25C70.7137 21.25 72.8125 19.1513 72.8125 16.5625C72.8125 13.9738 70.7137 11.875 68.125 11.875C65.5362 11.875 63.4375 13.9738 63.4375 16.5625Z',
    8: 'M7.1875 63.4375C7.1875 66.0263 9.28624 68.125 11.875 68.125C14.4637 68.125 16.5625 66.0263 16.5625 63.4375C16.5625 60.8488 14.4637 58.75 11.875 58.75C9.28624 58.75 7.1875 60.8488 7.1875 63.4375Z',
  }

  animateSvgPath('cards-planet', startPlanet, endPlanet)

  const startCloud = {
    1: 'M59.8502 50.3102H66.2691C72.5581 50.3102 77.6562 45.2119 77.6562 38.923C77.6562 32.634 72.558 27.5358 66.2691 27.5358H66.242C66.2422 27.5112 66.2439 27.4868 66.2439 27.4621C66.2439 20.2065 60.4392 14.3107 53.2208 14.1552C52.4502 7.53506 46.8267 2.396 40 2.396C33.1731 2.396 27.5498 7.53506 26.7792 14.1551C19.5609 14.3105 13.7561 20.2063 13.7561 27.4619C13.7561 27.4866 13.7578 27.511 13.758 27.5357H13.7309C7.44187 27.5357 2.34375 32.634 2.34375 38.9229C2.34375 45.2119 7.44203 50.3101 13.7309 50.3101H20.1498',
    2: 'M40.0002 55.6722C42.9472 55.6722 45.3363 53.2831 45.3363 50.3361C45.3363 47.3891 42.9472 45 40.0002 45C37.0531 45 34.6641 47.3891 34.6641 50.3361C34.6641 53.2831 37.0531 55.6722 40.0002 55.6722Z',
    3: 'M25.4845 77.6722C28.4316 77.6722 30.8206 75.2831 30.8206 72.3361C30.8206 69.3891 28.4316 67 25.4845 67C22.5375 67 20.1484 69.3891 20.1484 72.3361C20.1484 75.2831 22.5375 77.6722 25.4845 77.6722Z',
    4: 'M54.5138 77.6722C57.4609 77.6722 59.8499 75.2831 59.8499 72.3361C59.8499 69.3891 57.4609 67 54.5138 67C51.5668 67 49.1777 69.3891 49.1777 72.3361C49.1777 75.2831 51.5668 77.6722 54.5138 77.6722Z',

  }
  const endCloud = {
    1: 'M59.8502 50.3102H66.2691C72.5581 50.3102 77.6562 45.2119 77.6562 38.923C77.6562 32.634 72.558 27.5358 66.2691 27.5358H66.242C66.2422 27.5112 66.2439 27.4868 66.2439 27.4621C66.2439 20.2065 60.4392 14.3107 53.2208 14.1552C52.4502 7.53506 46.8267 2.396 40 2.396C33.1731 2.396 27.5498 7.53506 26.7792 14.1551C19.5609 14.3105 13.7561 20.2063 13.7561 27.4619C13.7561 27.4866 13.7578 27.511 13.758 27.5357H13.7309C7.44187 27.5357 2.34375 32.634 2.34375 38.9229C2.34375 45.2119 7.44203 50.3101 13.7309 50.3101H20.1498M30.8222 50.3102H49.1778',
    2: 'M40.0002 77.6038C42.9472 77.6038 45.3363 75.2148 45.3363 72.2677C45.3363 69.3207 42.9472 66.9316 40.0002 66.9316C37.0531 66.9316 34.6641 69.3207 34.6641 72.2677C34.6641 75.2148 37.0531 77.6038 40.0002 77.6038Z',
    3: 'M25.4865 55.6463C28.4335 55.6463 30.8226 53.2573 30.8226 50.3102C30.8226 47.3632 28.4335 44.9741 25.4865 44.9741C22.5394 44.9741 20.1504 47.3632 20.1504 50.3102C20.1504 53.2573 22.5394 55.6463 25.4865 55.6463Z',
    4: 'M54.5138 55.6463C57.4609 55.6463 59.8499 53.2573 59.8499 50.3102C59.8499 47.3632 57.4609 44.9741 54.5138 44.9741C51.5668 44.9741 49.1777 47.3632 49.1777 50.3102C49.1777 53.2573 51.5668 55.6463 54.5138 55.6463Z',
  }

  animateSvgPath('cards-cloud', startCloud, endCloud)

  const startWoocoomerce = {
    1: 'M1 38.0469V47.4484H8.10805C8.96123 51.8873 10.709 56.1061 13.2448 59.8479L8.21809 64.8746L17.2133 73.8698L22.24 68.8431C25.9818 71.3788 30.2006 73.1266 34.6395 73.9798V81.0879H47.3605V73.9798C51.7994 73.1266 56.0182 71.3789 59.76 68.8431L64.7867 73.8698L73.7819 64.8746L68.7552 59.8479C71.291 56.106 73.0387 51.8872 73.892 47.4484H81V38.0469H1Z',
    2: 'M61.326 38.0469C61.4502 38.9667 61.5124 39.8938 61.5121 40.822C61.5121 52.1509 52.3282 61.3348 40.9992 61.3348C29.6702 61.3348 20.4863 52.1509 20.4863 40.822C20.4863 39.8807 20.5497 38.9544 20.6724 38.0469',
    3: 'M41.0995 12.624C44.2756 12.624 46.8504 10.0514 46.8504 6.87789C46.8504 3.70443 44.2756 1.13184 41.0995 1.13184C37.9234 1.13184 35.3486 3.70443 35.3486 6.87789C35.3486 10.0514 37.9234 12.624 41.0995 12.624Z',
    4: 'M20.2656 21.7005C23.439 21.7005 26.0116 19.1257 26.0116 15.9496C26.0116 12.7735 23.439 10.1987 20.2656 10.1987C17.0921 10.1987 14.5195 12.7735 14.5195 15.9496C14.5195 19.1257 17.0921 21.7005 20.2656 21.7005Z',
    5: 'M24.2969 20.0469L30.5825 26.3325V38.0467',
    6: 'M61.5527 21.7005C64.7262 21.7005 67.2988 19.1257 67.2988 15.9496C67.2988 12.7735 64.7262 10.1987 61.5527 10.1987C58.3792 10.1987 55.8066 12.7735 55.8066 15.9496C55.8066 19.1257 58.3792 21.7005 61.5527 21.7005Z',
    7: 'M57.5215 20.047L51.2357 26.3327V38.0469M41.0996 12.5928V38.047',
  }
  const endWoocoomerce = {
    1: 'M1 38.0469V47.4484H8.10805C8.96123 51.8873 10.709 56.1061 13.2448 59.8479L8.21809 64.8746L17.2133 73.8698L22.24 68.8431C25.9818 71.3788 30.2006 73.1266 34.6395 73.9798V81.0879H47.3605V73.9798C51.7994 73.1266 56.0182 71.3789 59.76 68.8431L64.7867 73.8698L73.7819 64.8746L68.7552 59.8479C71.291 56.106 73.0387 51.8872 73.892 47.4484H81V38.0469H1Z',
    2: 'M61.326 38.0469C61.4502 38.9667 61.5124 39.8938 61.5121 40.822C61.5121 52.1509 52.3282 61.3348 40.9992 61.3348C29.6702 61.3348 20.4863 52.1509 20.4863 40.822C20.4863 39.8807 20.5497 38.9544 20.6724 38.0469',
    3: 'M41.0995 12.624C44.2756 12.624 46.8504 10.0514 46.8504 6.87789C46.8504 3.70443 44.2756 1.13184 41.0995 1.13184C37.9234 1.13184 35.3486 3.70443 35.3486 6.87789C35.3486 10.0514 37.9234 12.624 41.0995 12.624Z',
    4: 'M23.7461 25.5017C26.9195 25.5017 29.4921 22.927 29.4921 19.7509C29.4921 16.5748 26.9195 14 23.7461 14C20.5726 14 18 16.5748 18 19.7509C18 22.927 20.5726 25.5017 23.7461 25.5017Z',
    5: 'M28 23.5L30.5835 26.3325V38.0467',
    6: 'M58.7461 24.5017C61.9195 24.5017 64.4921 21.927 64.4921 18.7509C64.4921 15.5748 61.9195 13 58.7461 13C55.5726 13 53 15.5748 53 18.7509C53 21.927 55.5726 24.5017 58.7461 24.5017Z',
    7: 'M54.5 22.5L51.2357 26.3327V38.0469M41.0996 12.5928V38.047',
  }
  animateSvgPath('cards-woo', startWoocoomerce, endWoocoomerce)
  const startMemcashed = {
    1: 'M44.6874 35.3125C44.6874 37.9014 38.3915 40 30.625 40C22.8584 40 16.5625 37.9014 16.5625 35.3125C16.5625 32.7236 22.8584 30.625 30.625 30.625C38.3915 30.625 44.6874 32.7236 44.6874 35.3125Z',
    2: 'M16.5625 35.3126V63.4375C16.5625 66.0264 22.8584 68.125 30.625 68.125C38.3915 68.125 44.6874 66.0264 44.6874 63.4375V35.3126',
    3: 'M44.6874 41.6875C44.6874 44.2764 38.3915 46.375 30.625 46.375C22.8584 46.375 16.5625 44.2764 16.5625 41.6875',
    4: 'M44.6874 49.0625C44.6874 51.6514 38.3915 53.75 30.625 53.75C22.8584 53.75 16.5625 51.6514 16.5625 49.0625',
    5: 'M58.75 21.4966L77.9024 2.34398',
    6: 'M77.6562 21.25V2.34381H58.75',
    7: 'M79.9998 77.6562H2.34375V0.000229582',
    8: 'M2.34375 21.2502H58.7498V77.6562',
  }

  const endMemcashed = {
    1: 'M44.6874 35.3125C44.6874 37.9014 38.3915 40 30.625 40C22.8584 40 16.5625 37.9014 16.5625 35.3125C16.5625 32.7236 22.8584 30.625 30.625 30.625C38.3915 30.625 44.6874 32.7236 44.6874 35.3125Z',
    2: 'M16.5625 35.3126V63.4375C16.5625 66.0264 22.8584 68.125 30.625 68.125C38.3915 68.125 44.6874 66.0264 44.6874 63.4375V35.3126',
    3: 'M44.6874 50.6875C44.6874 53.2764 38.3915 55.375 30.625 55.375C22.8584 55.375 16.5625 53.2764 16.5625 50.6875',
    4: 'M44.6874 57.0625C44.6874 59.6514 38.3915 61.75 30.625 61.75C22.8584 61.75 16.5625 59.6514 16.5625 57.0625',
    5: 'M58.75 21.4966L77.9024 2.34398',
    6: 'M77.6562 16.25V2.34381H63.75',
    7: 'M69.9998 77.6562H2.34375V10.0002',
    8: 'M2.34375 21.2502H58.7498V77.6562',
  }
  animateSvgPath('cards-memcashed', startMemcashed, endMemcashed)

  const startQueue = {
    1: 'M57.1248 40.0694C58.177 37.1176 58.7498 33.9382 58.7498 30.6251C58.7498 15.092 46.158 2.34392 30.6249 2.34392C15.092 2.34392 2.34375 15.092 2.34375 30.6251C2.34375 38.7232 5.94218 46.0004 11.4195 51.1322L7.18749 58.75H30.6249C33.938 58.75 37.1176 58.177 40.0694 57.125',
    2: 'M77.6561 58.7501C77.6561 48.3946 69.1054 40.0001 58.7499 40.0001C48.3945 40.0001 40 48.3946 40 58.7501C40 69.1055 48.3945 77.6562 58.7499 77.6562H72.8124L70.3421 73.5392C74.6707 70.1046 77.6561 64.705 77.6561 58.7501Z',
    3: 'M58.75 67.0938V50.4063',
    4: 'M49.375 61.0938V56.4063',
    5: 'M68.125 61.0938V56.4063',
    6: 'M24.2188 30.625H37.0312',
    7: 'M13.5938 21.25H47.6562',
    8: 'M19.5938 40H41.6562',
  }
  const endQueue = {
    1: 'M57.1248 40.0694C58.177 37.1176 58.7498 33.9382 58.7498 30.6251C58.7498 15.092 46.158 2.34392 30.6249 2.34392C15.092 2.34392 2.34375 15.092 2.34375 30.6251C2.34375 38.7232 5.94218 46.0004 11.4195 51.1322L7.18749 58.75H30.6249C33.938 58.75 37.1176 58.177 40.0694 57.125',
    2: 'M77.6561 58.7501C77.6561 48.3946 69.1054 40.0001 58.7499 40.0001C48.3945 40.0001 40 48.3946 40 58.7501C40 69.1055 48.3945 77.6562 58.7499 77.6562H72.8124L70.3421 73.5392C74.6707 70.1046 77.6561 64.705 77.6561 58.7501Z',
    3: 'M58.75 61.0938V56.4063',
    4: 'M49.375 61.0938V56.4063',
    5: 'M68.125 61.0938V56.4063',
    6: 'M14.2188 30.625H47.0311',
    7: 'M23.5938 21.25H37.6562',
    8: 'M23.5938 40H37.6562',
  }
  animateSvgPath('cards-queue', startQueue, endQueue)
  const startWix = {
    1: 'M25.9374 58.75H2.34375V2.34392H63.4373V35.3126',
    2: 'M2.34375 21.0938H63.4373',
    3: 'M32.9687 11.7188H14.2188',
    4: 'M70.6251 49.375H65.375',
    5: 'M55 49.375H32.9688',
    6: 'M70.625 63.4375H47.4375',
    7: 'M38.0626 63.4375H32.9688',
    8: 'M49.375 14.0625V9.37501',
    9: 'M40 14.0625V9.37501',
    10: 'M25.9375 77.6562H77.6561V35.3126H25.9375V77.6562Z',
    11: 'M65.375 49.375C65.375 51.9639 63.2762 54.0625 60.6875 54.0625C58.0987 54.0625 56 51.9639 56 49.375C56 46.7861 58.0987 44.6875 60.6875 44.6875C63.2762 44.6875 65.375 46.7861 65.375 49.375Z',
    12: 'M47.4375 63.4375C47.4375 66.0264 45.3387 68.125 42.75 68.125C40.1612 68.125 38.0625 66.0264 38.0625 63.4375C38.0625 60.8486 40.1612 58.75 42.75 58.75C45.3387 58.75 47.4375 60.8486 47.4375 63.4375Z',
  }
  const endWix = {
    1: 'M25.9374 58.75H2.34375V2.34392H63.4373V35.3126',
    2: 'M2.34375 21.0938H63.4373',
    3: 'M32.9687 11.7188H14.2188',
    4: 'M70.6251 49.375H49.375',
    5: 'M40 49.375H32.9688',
    6: 'M70.625 63.4375H63.4375',
    7: 'M54.0626 63.4375H32.9688',
    8: 'M49.375 14.0625V9.37501',
    9: 'M40 14.0625V9.37501',
    10: 'M25.9375 77.6562H77.6561V35.3126H25.9375V77.6562Z',
    11: 'M49.375 49.375C49.375 51.9639 47.2762 54.0625 44.6875 54.0625C42.0987 54.0625 40 51.9639 40 49.375C40 46.7861 42.0987 44.6875 44.6875 44.6875C47.2762 44.6875 49.375 46.7861 49.375 49.375Z',
    12: 'M63.4375 63.4375C63.4375 66.0264 61.3387 68.125 58.75 68.125C56.1612 68.125 54.0625 66.0264 54.0625 63.4375C54.0625 60.8486 56.1612 58.75 58.75 58.75C61.3387 58.75 63.4375 60.8486 63.4375 63.4375Z',
  }
  animateSvgPath('cards-wix', startWix, endWix)
  const startTilda = {
    1: 'M63.5936 58.9062H2.34375V2.34392H63.5936V58.9062Z',
    2: 'M2.34375 21.25H63.5936',
    3: 'M32.9687 11.875H14.2188',
    4: 'M52.0625 30.625H38',
    5: 'M23.375 30.625H14',
    6: 'M32.75 30.625H28.0625',
    7: 'M28.0625 40H14',
    8: 'M37.6875 40H33',
    9: 'M52.375 40H43',
    10: 'M18.6875 49.375H14',
    11: 'M28.0625 49.375H23.375',
    12: 'M37.4375 49.375H32.75',
    13: 'M49.375 14.2188V9.53126',
    14: 'M40 14.2188V9.53126',
    15: 'M21.25 58.9063V68.2812H77.6561V30.6251H63.5936',
    16: 'M32.9688 77.6562H65.9374',
    17: 'M49.375 77.6562V68.2813',
  }
  const endTilda = {
    1: 'M63.5936 58.9062H2.34375V2.34392H63.5936V58.9062Z',
    2: 'M2.34375 21.25H63.5936',
    3: 'M32.9687 11.875H14.2188',
    4: 'M28.2812 30.625H14.2188',
    5: 'M42.3437 30.625H32.9688',
    6: 'M51.7187 30.625H47.0312',
    7: 'M51.7187 40H37.6562',
    8: 'M32.9687 40H28.2812',
    9: 'M23.5937 40H14.2188',
    10: 'M18.9062 49.375H14.2188',
    11: 'M28.2812 49.375H23.5938',
    12: 'M37.6562 49.375H32.9688',
    13: 'M49.375 14.2188V9.53126',
    14: 'M40 14.2188V9.53126',
    15: 'M21.25 58.9063V68.2812H77.6561V30.6251H63.5936',
    16: 'M32.9688 77.6562H65.9374',
    17: 'M49.375 77.6562V68.2813',
  }
  animateSvgPath('cards-tilda', startTilda, endTilda)
}



// WEBPACK FOOTER //
// ./src/js/components/js-component/animateSvg.js